import React, { useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import Home from "./components/Home/Home";
import Footer from "./components/Footer/Footer";
import WhyChooseUs from "./components/WhyChooseUs/WhyChooseUs";
import Projects from "./components/Projects/Projects";
import Map from "./components/Map/Map";

const App = () => {
  const contactRef = useRef(null);

  const onContactClick = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Router>
      <Header onContactClick={onContactClick} />
      <Routes>
        <Route path="/" element={<Home contactRef={contactRef} />} />
        <Route path="/why-choose-us" element={<WhyChooseUs />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/our-location" element={<Map />} />
      </Routes>
      <Footer contactRef={contactRef} />
    </Router>
  );
};

export default App;
